export default __webpack_public_path__ + "pets.eebca9f.png";